import React from 'react';
import ProductListingLayoutProps from './ProductListingLayoutProps';

const Grid3by3 = ({ children }: ProductListingLayoutProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-4 lg:grid-cols-6">
      {children}
    </div>
  );
};

export default Grid3by3;
